/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { If, Then, Else } from "react-if";
import { Heading, Button, FlexContainer } from "@nordcloud/gnui";
import logo from "~/assets/images/ninja.png";

type Props = {
  error: Error;
  resetErrorBoundary?: () => void;
  message?: React.ReactNode;
};

export function ErrorFallback({ error, resetErrorBoundary, message = "Close" }: Props) {
  return (
    <div css={{ flex: "1 0 auto", paddingBottom: "3rem", paddingTop: "8rem" }}>
      <FlexContainer justifyContent="center">
        <img alt="logo" src={logo} css={{ width: "30rem", maxWidth: "50%", height: "auto" }} />
        <div>
          <div css={{ transform: "rotate(-15deg)" }}>
            <Heading level={1} mb={0}>
              Ooooops
            </Heading>
            <Heading level={4} mb={3}>
              <If condition={error.message}>
                <Then>{error.message}</Then>
                <Else>
                  Looks like this page is broken.
                  <br /> Our cloud ninjas are on their way to fix it.
                  <br /> In the meantime you can:
                </Else>
              </If>
            </Heading>
            <Heading level={2}>
              <Button onClick={resetErrorBoundary}>{message}</Button>
            </Heading>
          </div>
        </div>
      </FlexContainer>
    </div>
  );
}
